export default __webpack_public_path__ + "static/media/cadeado.47547474.png";